import { render, staticRenderFns } from "./my-vaccinations.vue?vue&type=template&id=31d5af1f&"
import script from "./my-vaccinations.vue?vue&type=script&lang=js&"
export * from "./my-vaccinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports